import actionTypes from '../common/actionTypes';
import { defaultUser, defaultCustomerNote } from './userAPI';
import Utils from '../common/utils';

interface State {
	user: UserDetails;
	customers: UserDetails[];
	softDeclinedCustomers: SoftDeclinedUserDetailsDto[];
	admins: UserDetails[];
	note: CustomerNote;
	notes: CustomerNote[];
	referrals: CustomerReferralResponse;
	referrerName: string;
}
const initialState: State = {
	user: defaultUser,
	customers: [],
	softDeclinedCustomers: [],
	admins: [],
	note: defaultCustomerNote,
	notes: [],
	referrals: {
		referralCode: '',
		spousalReferralCode: '',
		referees: [],
		healthScore: 50,
		referralBalance: 0,
		remainingReferrals: 0,

		referralEnabled: false,
		pendingReferral: 0,
		paidReferral: 0,
		referredSpouseName: '',
		referredSpouseEmail: '',
		referredSpouseExpiryDate: '',
		isSpousalReferralUsed: false,
		statusId: '',
	},
	referrerName: ''
};
export default function userReducer(state: State = initialState, action: any) {
	switch (action.type) {
		case actionTypes.RESET_USER:
			const resetUser = defaultUser;
			const defaultReferrals = initialState.referrals;
			if (state.referrals.referralCode) {
				defaultReferrals.referralCode = state.referrals.referralCode;
			}
			return { ...state, user: resetUser, referrals: defaultReferrals };
		case actionTypes.SET_USER:
			return { ...state, user: action.user };
		case actionTypes.FETCH_USER:
		case actionTypes.SAVE_USER:
		case actionTypes.UPDATE_CUSTOMER_REFERREDBY_SUCCESS:
			const user: UserDetails = action.user;
			if (user.birthDate) {
				user.birthDate = Utils.formatDateAsUTC(user.birthDate);
			}

			return { ...state, user: user };
		case actionTypes.FETCH_SOFT_DECLINED_CUSTOMERS:
			return { ...state, softDeclinedCustomers: action.customers };
		case actionTypes.FETCH_CUSTOMERS:
		case actionTypes.FETCH_CUSTOMERS_MISSING_BENEFICIARY_FORMS:
			return { ...state, customers: action.customers };
		case actionTypes.FETCH_ADMINS:
			return { ...state, admins: action.admins };
		case actionTypes.RESET_CUSTOMER_NOTES:
			const note: CustomerNote = {...defaultCustomerNote};
			note.customerId = action.customerId;
			return {...state, note };
		case actionTypes.SET_CUSTOMER_NOTE:
		case actionTypes.FETCH_CUSTOMER_NOTE:
		case actionTypes.SAVE_CUSTOMER_NOTE:
			return { ...state, note: action.note };
		case actionTypes.FETCH_CUSTOMER_NOTES:
			return { ...state, notes: action.notes };
		case actionTypes.RESET_CUSTOMER_ANSWER_NOTES:
			const answerNote: CustomerNote = {...defaultCustomerNote};
			answerNote.customerId = action.customerId;
			answerNote.answerId = action.answerId;
			return {...state, note: answerNote };
		case actionTypes.RESET_CUSTOMER_REFERRALS:
			return { ...state, referrals: initialState.referrals };
		case actionTypes.FETCH_CUSTOMER_REFERRALS_SUCCESS:
			return { ...state, referrals: action.referrals };
		case actionTypes.SET_CUSTOMER_REMAINING_REFERRALS:
		case actionTypes.UPDATE_REMAINING_REFERRALS_SUCCESS:
			return {
				...state,
				referrals: { ...state.referrals, remainingReferrals: action.remainingReferrals }
			};
		case actionTypes.SET_CUSTOMER_REFERRAL_BALANCE:
			return {
				...state,
				referrals: {...state.referrals, referralBalance: action.referralBalance}
			};
		case actionTypes.UPDATE_REFERAL_BALANCE_SUCCESS:
			return {
				...state,
				referrals: {...state.referrals, referralBalance: action.referralBalance}
			};
		case actionTypes.UPDATE_REFERRAL_ENABLED_SUCCESS:
			return {
				...state,
				referrals: {...state.referrals, referralEnabled: action.referralEnabled}
			};
		case actionTypes.GENERATE_NEW_REFERRALCODE_SUCCESS:
		case actionTypes.SET_REFERRALCODE_SUCCESS:
			return {
				...state,
				referrals: { ...state.referrals, referralCode: action.referralCode }
			};
		case actionTypes.SET_SPOUSALREFERRALCODE_SUCCESS:
			return {
				...state,
				referrals: {...state.referrals, spousalReferralCode: action.spousalReferralCode}
			};
		case actionTypes.FETCH_REFERRER_NAME_BY_REFERRAL_CODE_SUCCESS:
		case actionTypes.FETCH_REFERRER_NAME_BY_SPOUSAL_REFERRAL_CODE_SUCCESS:
			return { ...state, referrerName: action.referrerName };
		case actionTypes.CLEAR_ADJUDICATION_QUEUE:
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/user/userReducer.ts